import { useMutation } from "@tanstack/react-query";

import { postImportFieldHistoryCsv, postValidateFieldHistoryCsv } from "../../services";

export const useValidateFieldHistoryImport = () =>
	useMutation({
		mutationFn: (file: File) => postValidateFieldHistoryCsv(file),
		meta: { errorMessage: "Unable to validate the file." },
	});

/**
 * Success only means the work was accepted; the outcome arrives over the task's status stream. Default
 * toast off because the page renders these itself — a 409 needs to stay on screen, not scroll past.
 */
export const useImportFieldHistory = () =>
	useMutation({
		mutationFn: ({ file, employeeCount }: { file: File; employeeCount: number }) =>
			postImportFieldHistoryCsv(file, employeeCount),
		meta: { disableDefaultErrorHandling: true },
	});
